import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components';

export enum ComponentIcons {
	Groups = 'adbComponent:groups',
	Users = 'adbComponent:users',
	Modules = 'adbComponent:modules',
}

@Injectable()
export class AppUiComponentIcons extends AppIcons {
	private readonly path = './assets/img';
	protected override namespace = 'adbComponent';

	protected icons: IIcons = {
		[ComponentIcons.Groups]: `${this.path}/common/groups_FILL1_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Users]: `${this.path}/common/users_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[ComponentIcons.Modules]: `${this.path}/module/select_window_24dp_E8EAED_FILL0_wght100_GRAD0_opsz48.svg`,
	};
}
